<template>
  <el-cascader
    v-model="val"
    :props="{ value: 'code',label:'name',checkStrictly:false,expandTrigger:'hover'}"
    placeholder="请选择专业或学科"
    :options="treeData"
    :show-all-levels="false"
    clearable
    filterable
  ></el-cascader>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ZrCombobox",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      val: [],
    };
  },
  watch: {
    value: {
      handler: function (v) {
        this.val = [];
        this.val= v.split(",");
      },
      immediate: true,
    },
    val(v) {
      this.$emit("change", v.join(',') || "");
      // this.$emit("change", v[v.length - 1] || "");
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
